import React, { forwardRef } from 'react';
import Box from '../Box/Box.js';
import { IconButton } from '../Button/IconButton.js';
import '../Button/ButtonBase.js';
import '../utils/defaultSxProp.js';
import { ButtonComponent } from '../Button/Button.js';
import { clsx } from 'clsx';
import '../FeatureFlags/FeatureFlags.js';
import { useFeatureFlag } from '../FeatureFlags/useFeatureFlag.js';
import '../FeatureFlags/DefaultFeatureFlags.js';
import classes from './ActionList.module.css.js';
import { actionListCssModulesFlag } from './featureflag.js';

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const TrailingAction = /*#__PURE__*/forwardRef(({
  as = 'button',
  icon,
  label,
  href = null,
  className,
  ...props
}, forwardedRef) => {
  const enabled = useFeatureFlag(actionListCssModulesFlag);
  if (enabled) {
    return /*#__PURE__*/React.createElement("span", {
      className: clsx(className, classes.TrailingAction)
    }, icon ? /*#__PURE__*/React.createElement(IconButton, _extends({
      as: as,
      "aria-label": label,
      icon: icon,
      variant: "invisible",
      tooltipDirection: "w",
      href: href
      // @ts-expect-error StyledButton wants both Anchor and Button refs
      ,
      ref: forwardedRef,
      className: classes.TrailingActionButton
    }, props)) :
    /*#__PURE__*/
    // @ts-expect-error shhh
    React.createElement(ButtonComponent, _extends({
      variant: "invisible",
      as: as,
      href: href,
      ref: forwardedRef,
      className: classes.TrailingActionButton
    }, props), label));
  }
  return /*#__PURE__*/React.createElement(Box, {
    as: "span",
    "data-component": "ActionList.TrailingAction",
    sx: {
      flexShrink: 0
    },
    className: className
  }, icon ? /*#__PURE__*/React.createElement(IconButton, _extends({
    as: as,
    "aria-label": label,
    icon: icon,
    variant: "invisible",
    tooltipDirection: "w",
    href: href
    // @ts-expect-error StyledButton wants both Anchor and Button refs
    ,
    ref: forwardedRef
  }, props)) :
  /*#__PURE__*/
  // @ts-expect-error shhh
  React.createElement(ButtonComponent, _extends({
    variant: "invisible",
    as: as,
    href: href,
    ref: forwardedRef
  }, props), label));
});
TrailingAction.displayName = 'ActionList.TrailingAction';

export { TrailingAction };
